<template>
  <div id="menu-speaker"></div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {
    // 创建扬声器菜单
    BJY.SpeakerMenu.create({
      element: $('#menu-speaker'),
      // 是否可以选择设备
      // canSelectDevice: true,
      // 是否可以调节音量
      canAdjustVolume: true,
      // 最大音量
      maxVolume: 100,
      canSelectDevice: BJY.auth.canSelectSpeaker()
    })
  },
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
//@import url() 引入公共css类
</style>
